import * as React from "react";
import { CardElement } from "@stripe/react-stripe-js";
import "../assets/css/CardSectionStyles.css";
import { Input, InputGroup, InputLeftElement } from "@chakra-ui/input";
import { AtSignIcon } from "@chakra-ui/icons";
import { MdAccountCircle } from "react-icons/md";
import { Icon } from "@chakra-ui/react";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "18px",
      "::placeholder": {
        color: "#aab7c4",
      },
      fontWeight: "normal",
      padding: "10px",
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

export const CardSection: React.FC<any> = ({ handleChange }) => {
  return (
    <>
      <InputGroup marginBottom="10px">
        <InputLeftElement
          pointerEvents="none"
          children={<Icon as={MdAccountCircle} w={5} h={5} marginTop="5px" />}
        />
        <Input
          placeholder="Enter your full name  "
          size="lg"
          name="fullName"
          onChange={(e) => handleChange(e)}
          fontWeight="normal"
        />
      </InputGroup>
      <InputGroup marginBottom="10px">
        <InputLeftElement
          pointerEvents="none"
          children={<AtSignIcon marginTop="6px" />}
        />
        <Input
          placeholder="Enter your email address "
          size="lg"
          name="email"
          onChange={(e) => handleChange(e)}
          fontWeight="normal"
        />
      </InputGroup>
      <CardElement options={CARD_ELEMENT_OPTIONS} />
    </>
  );
};
